/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetOtherRegistries200ResponseData } from './GetOtherRegistries200ResponseData'
import {
  GetOtherRegistries200ResponseDataFromJSON,
  GetOtherRegistries200ResponseDataFromJSONTyped,
  GetOtherRegistries200ResponseDataToJSON,
} from './GetOtherRegistries200ResponseData'

/**
 *
 * @export
 * @interface GetOtherRegistries200Response
 */
export interface GetOtherRegistries200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetOtherRegistries200Response
   */
  status: boolean
  /**
   *
   * @type {GetOtherRegistries200ResponseData}
   * @memberof GetOtherRegistries200Response
   */
  data: GetOtherRegistries200ResponseData
}

/**
 * Check if a given object implements the GetOtherRegistries200Response interface.
 */
export function instanceOfGetOtherRegistries200Response(
  value: object
): value is GetOtherRegistries200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetOtherRegistries200ResponseFromJSON(
  json: any
): GetOtherRegistries200Response {
  return GetOtherRegistries200ResponseFromJSONTyped(json, false)
}

export function GetOtherRegistries200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetOtherRegistries200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetOtherRegistries200ResponseDataFromJSON(json['data']),
  }
}

export function GetOtherRegistries200ResponseToJSON(
  value?: GetOtherRegistries200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetOtherRegistries200ResponseDataToJSON(value['data']),
  }
}
